// 1. Dependencies
import { nodeConfig } from '@scripts/mixins';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// 2. Configuration
export const NAMESPACE = 'production-sticky-performances';
export const DEFAULT_SELECTOR = '[data-js-production-sticky-performances]';
export const DEFAULT_SETTINGS = {
};

// 3. Module
export class ProductionStickyPerformances {
	/** @param {HTMLElement} node */
	constructor(node, config) {
		this.elNode = node;
		this.elPreviousSibling;
	}

	bindUI() {
		ScrollTrigger.create({
			trigger: this.elPreviousSibling,
			start: 'bottom 50px',
			end: '+=1px',
			onEnter: () => {
				this.elNode.classList.add('state-sticky');
			},
			onLeaveBack: () => {
				this.elNode.classList.remove('state-sticky');
			},
		});
	}

	findPreviousSibling() {
		let sibling = this.elNode.previousElementSibling;
		while (sibling && sibling.tagName.toLowerCase() === 'dialog') {
			sibling = sibling.previousElementSibling;
		}
		this.elPreviousSibling = sibling;
	}

	init() {
		this.findPreviousSibling();
		if (!this.elPreviousSibling) return;

		this.bindUI();
	}
}

// 4. Factory Function
export default function factory(selector = DEFAULT_SELECTOR, settings = {}) {
	const listNode = document.querySelectorAll(selector);

	if (!listNode.length) return;

	return Array.from(listNode).map((node) => {
		const config = nodeConfig(node, NAMESPACE, settings, DEFAULT_SETTINGS);
		const module = new ProductionStickyPerformances(node, config);

		module.init();

		return module;
	});
}
